// extracted by mini-css-extract-plugin
export var active = "styles-module--active--ab117";
export var buttonFilled = "styles-module--button-filled--63c18";
export var buttonOutlined = "styles-module--button-outlined--e4e53";
export var card = "styles-module--card--6838c";
export var check = "styles-module--check--96676";
export var description = "styles-module--description--94d13";
export var details = "styles-module--details--034e4";
export var highlight = "styles-module--highlight--b600f";
export var price = "styles-module--price--11602";
export var small = "styles-module--small--e13f0";
export var smallGray = "styles-module--small-gray--71772";
export var title = "styles-module--title--f6355";